class UserDto {
    Id: number;
    Email: string;
    FirstName: string;
    LastName: string;

    constructor(id: number, email: string, firstName: string, lastName: string) {
        this.Id = id;
        this.Email = email;
        this.FirstName = firstName;
        this.LastName = lastName;
    }

    get Label(): string {
        if ((!this.FirstName || this.FirstName.trim() === '') && (!this.LastName || this.LastName.trim() === '')) {
            return this.Email;
        }
        return `${this.FirstName} ${this.LastName}`.trim();
    }
}

export default UserDto;
